import { VIEW_TITLES, nav, varsayilanGorunum } from "./nav.js";
import { ROLLER, demoKullanicilar, erisilebilirSubeler, girisYap, kiraciDegistir, ogrenciyiGorebilir, oturum, rol, sinifaYazabilir, subeyeErisebilir, yapabilir } from "./domain/auth.js";
import { viewVeliBugun } from "./views/veli/bugun.js";
import { viewVeliOdemelerim } from "./views/veli/odemelerim.js";
import { routeFromHash } from "./router.js";
import { firebaseHazir } from "./config.js";
import { B, T, cls, kiraciBul, staffOf, stu } from "./domain/context.js";
import { Bildirim, Hatirlatma, Kiraci, Mesajlar, Ogrenciler, Yoklama } from "./repo/entities.js";
import { MERDIVEN, hatirlatmaTablosu, metinUret, taksitPlanlari } from "./domain/reminders.js";
import { veliler } from "./domain/students.js";
import { openTaksitFormu } from "./components/taksitForm.js";
import { openDuyuruFormu } from "./components/duyuruForm.js";
import { Duyuru } from "./repo/entities.js";
import { duyuruDurumu, duyurular } from "./domain/announcements.js";
import { bildirimPaneli, bildirimRozeti } from "./components/notifications.js";
import { bekleyenYazma, cevrimici, guncellemeHazir, guncellemeyiUygula } from "./lib/offline.js";
import { KANALLAR, bildirimler } from "./domain/notifications.js";
import { bindApplicationEvents, viewBasvurular } from "./views/basvurular.js";
import { bindPhotoEvents } from "./bindings/photo.js";
import { closeModal, openStudentModal } from "./components/studentModal.js";
import { esc } from "./lib/fmt.js";
import { state } from "./state.js";
import { viewAyarlar } from "./views/ayarlar.js";
import { viewEtkinlikler } from "./views/etkinlikler.js";
import { viewMenu } from "./views/menu.js";
import { viewMesajlar } from "./views/mesajlar.js";
import { viewOdemeler } from "./views/odemeler.js";
import { viewOgrenciler } from "./views/ogrenciler.js";
import { viewPanel } from "./views/panel.js";
import { viewPersonel } from "./views/personel.js";
import { viewPersonelDetay } from "./views/personelDetay.js";
import { viewRapor } from "./views/rapor.js";
import { viewSinifDetay } from "./views/sinifDetay.js";
import { viewSiniflar } from "./views/siniflar.js";
import { openCheckoutModal, viewYoklama } from "./views/yoklama.js";
import { viewSaglik } from "./views/saglik.js";
import { viewFinans } from "./views/finans.js";
import { viewRaporlar } from "./views/raporlar.js";
import { viewSistem } from "./views/sistem.js";
import { viewAbonelik } from "./views/abonelik.js";
import { dokumIndir } from "./components/kvkk.js";
import { aktarimUret, dosyaIndir } from "./components/export.js";
import { AKTARIMLAR } from "./domain/export.js";
import { belgeAc } from "./components/receipts.js";
import { odemeBaglantisi } from "./domain/receipts.js";
import { cocuklarim } from "./domain/auth.js";
import { subeBulHerYerde } from "./domain/context.js";
import { Aktarim } from "./repo/entities.js";
import { dokumDosyasi } from "./domain/kvkk.js";
import { Ilac, Olay } from "./repo/entities.js";
import { aktifIlaclar, olaylar } from "./domain/health.js";

// ============================================================
// RENDER & OLAYLAR
// ============================================================

export const VIEWS = {
  panel: viewPanel, yoklama: viewYoklama, rapor: viewRapor, menu: viewMenu,
  ogrenciler: viewOgrenciler, siniflar: viewSiniflar, personel: viewPersonel,
  mesajlar: viewMesajlar, odemeler: viewOdemeler, basvurular: viewBasvurular,
  etkinlikler: viewEtkinlikler, ayarlar: viewAyarlar, saglik: viewSaglik,
  bugun: viewVeliBugun, odemelerim: viewVeliOdemelerim, finans: viewFinans,
  sistem: viewSistem, abonelik: viewAbonelik, raporlar: viewRaporlar,
};

export function renderNav() {
  document.getElementById("nav").innerHTML = nav().map(g => `
    <div>
      <div class="px-3 pb-1.5 text-[10px] font-bold uppercase tracking-widest text-white/35">${g.group}</div>
      ${g.items.map(i => `
        <a href="#/${i.id}" data-view="${i.id}"
          class="nav-item relative flex items-center gap-3 rounded-xl px-3 py-2 mb-0.5 hover:bg-white/5 hover:text-white transition ${state.view === i.id ? "active" : ""}">
          <span class="nav-crayon absolute left-0 top-2 bottom-2 w-1 rounded-full bg-gradient-to-b from-sun via-coral to-grape"></span>
          <span class="text-base w-6 text-center">${i.icon}</span>
          <span class="font-medium">${i.label}</span>
          ${i.id === "mesajlar" && rol() !== "veli" && B().messages.some(m => m.unread)
            ? `<span class="ml-auto text-[10px] font-bold bg-coral text-white rounded-full px-1.5 py-0.5">${B().messages.filter(m => m.unread).length}</span>` : ""}
        </a>`).join("")}
    </div>`).join("");
}

export function renderBranch() {
  const o = oturum();

  // Kullanıcı kimliği her rolde yazılır — sistem operatörü dahil.
  document.getElementById("userInitials").textContent = bashafler(o?.name ?? "");
  document.getElementById("userName").textContent = o?.name ?? "";
  document.getElementById("userRole").textContent = ROLLER[o?.role]?.label ?? "";

  // Sistem operatörünün kiracısı yok; şube seçici ona anlamsız ve
  // yanıltıcı — bir kreşin adını taşıdığı için "o kreşin içindeyim"
  // izlenimi veriyordu. Gizleniyor.
  const secici = document.getElementById("branchBtn")?.parentElement;
  if (o?.role === "sistem") {
    if (secici) secici.classList.add("hidden");
    return;
  }
  if (secici) secici.classList.remove("hidden");

  const t = B();

  document.getElementById("branchOrg").textContent = T().name;
  document.getElementById("branchName").textContent = t.name;

  // Şube listesi kullanıcının erişebildikleriyle sınırlı — müdür başka
  // şubeyi göremez, veli hiç göremez.
  document.getElementById("branchMenu").innerHTML = erisilebilirSubeler().map(x => `
    <button data-branch="${x.id}" class="w-full flex items-center gap-3 px-4 py-3 text-left text-sm hover:bg-paper ${x.id === t.id ? "bg-paper" : ""}">
      <span class="w-2 h-2 rounded-full ${x.id === t.id ? "bg-teal" : "bg-line"}"></span>
      <span class="flex-1">
        <span class="block font-semibold">${esc(x.name)}</span>
        <span class="block text-[11px] text-inksoft">${x.students.length} öğrenci · ${x.classes.length} sınıf</span>
      </span>
      ${x.id === t.id ? `<span class="text-teal text-xs font-bold">✓</span>` : ""}
    </button>`).join("");
}

const bashafler = ad => ad.split(/\s+/).filter(Boolean).slice(0, 2)
  .map(x => x[0].toLocaleUpperCase("tr-TR")).join("");

// İki hâli var. Gerçek girişte rol değiştirmek YOK — rol claim'den
// gelir ve istemci onu değiştiremez; menü yalnızca kimin girdiğini
// gösterip çıkış sunar. Demo kurulumunda ise rol denemesi listesi
// çıkar; satış sunumu buna bağlı.
function renderUserMenu() {
  const simdiki = oturum();

  if (firebaseHazir) {
    document.getElementById("userMenu").innerHTML = `
      <div class="px-4 py-3 border-b border-line">
        <div class="font-semibold text-sm truncate">${esc(simdiki?.name ?? "")}</div>
        <div class="text-[11px] text-inksoft truncate">${esc(simdiki?.email ?? "")}</div>
        <div class="text-[11px] text-inksoft mt-0.5">${esc(ROLLER[simdiki?.role]?.label ?? "")}</div>
      </div>
      <button data-cikis class="w-full px-4 py-2.5 text-left text-sm font-semibold hover:bg-paper">
        Çıkış yap
      </button>`;
    return;
  }

  document.getElementById("userMenu").innerHTML = `
    <div class="px-4 py-2 text-[10px] font-bold uppercase tracking-widest text-inksoft bg-paper">
      Rol denemesi
    </div>
    ${demoKullanicilar().map(u => `
      <button data-user="${u.uid}" class="w-full flex items-center gap-3 px-4 py-2.5 text-left text-sm hover:bg-paper ${u.uid === simdiki?.uid ? "bg-paper" : ""}">
        <span class="w-2 h-2 rounded-full shrink-0 ${u.uid === simdiki?.uid ? "bg-teal" : "bg-line"}"></span>
        <span class="min-w-0 flex-1">
          <span class="block font-semibold truncate">${esc(u.name)}</span>
          <span class="block text-[11px] text-inksoft truncate">${esc(ROLLER[u.role].label)} · ${esc(u.title)}</span>
        </span>
        ${u.uid === simdiki?.uid ? `<span class="text-teal text-xs font-bold shrink-0">✓</span>` : ""}
      </button>`).join("")}`;
}

// Ağ durumu ve güncelleme şeridi. Çevrimdışıyken bekleyen yazma
// sayısını gösterir — "kaydedildi" deyip hiçbir yere göndermemek,
// çevrimdışı çalışmamaktan daha kötüdür.
function renderNetBar() {
  const bar = document.getElementById("netBar");
  if (!bar) return;

  if (guncellemeHazir()) {
    bar.className = "fixed top-0 inset-x-0 z-[60] text-center text-xs font-semibold py-2 bg-teal text-white";
    bar.innerHTML = `Yeni sürüm hazır.
      <button id="swUpdate" class="underline font-bold ml-1">Yenile</button>`;
    bar.querySelector("#swUpdate").onclick = guncellemeyiUygula;
    return;
  }

  if (!cevrimici()) {
    const bekleyen = bekleyenYazma();
    bar.className = "fixed top-0 inset-x-0 z-[60] text-center text-xs font-semibold py-2 bg-ink text-white";
    bar.textContent = bekleyen
      ? `Çevrimdışı — ${bekleyen} değişiklik bekliyor, ağ gelince gönderilecek`
      : "Çevrimdışı — değişiklikler cihazda saklanıyor";
    bar.classList.remove("hidden");
    return;
  }

  bar.className = "hidden";
}

export function render() {
  const t = B();
  renderNav();
  renderBranch();
  renderUserMenu();
  renderNetBar();

  const sinif = state.view === "siniflar" && state.classId ? cls(state.classId) : null;
  const kisi = state.view === "personel" && state.staffId ? staffOf(state.staffId) : null;

  document.getElementById("pageTitle").textContent =
    sinif ? `${sinif.name} Sınıfı` : kisi ? kisi.name : VIEW_TITLES[state.view] ?? "Panel";
  document.getElementById("pageDate").textContent =
    sinif ? `Sınıflar · ${sinif.age} · ${sinif.room}`
    : kisi ? `Personel · ${kisi.role}`
    : new Date().toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric", weekday: "long" });

  // Üst şerit ve bildirim zili kurum operasyonuna ait. Sistem
  // operatörünün bunlarla işi yok ve bildirimler ÇOCUK ADI taşıyor
  // ("Kuzey bugün gelmedi") — kenar çubuğunu kapatıp bu kapıyı açık
  // bırakmak sınırı anlamsız kılardı.
  const sistemOperatoru = rol() === "sistem";
  const zil = document.getElementById("notifBtn");

  // Şerit "hidden sm:flex" ile duyarlı; hidden sınıfını oynatmak
  // mobil davranışını bozar. Bu yüzden style ile gizliyoruz.
  const serit = document.getElementById("livePresence").closest("div");
  serit.style.display = sistemOperatoru ? "none" : "";
  if (zil) zil.style.display = sistemOperatoru ? "none" : "";

  if (sistemOperatoru) {
    state.notifOpen = false;
    document.getElementById("notifPanel").classList.add("hidden");
  } else {
    const here = Object.values(t.attendance).filter(a => a.status === "geldi").length;
    document.getElementById("livePresence").textContent =
      rol() === "veli" ? `${esc(t.name)}` : `Şu an okulda ${here} çocuk`;
    document.getElementById("notifBadge").innerHTML = bildirimRozeti();
    const panel = document.getElementById("notifPanel");
    panel.classList.toggle("hidden", !state.notifOpen);
    zil?.setAttribute("aria-expanded", String(state.notifOpen));
    if (state.notifOpen) {
      panel.innerHTML = bildirimPaneli();
      bindNotifEvents(panel);
    }
  }

  const view = document.getElementById("view");
  const renderFn = sinif ? viewSinifDetay : kisi ? viewPersonelDetay : (VIEWS[state.view] ?? viewPanel);
  view.innerHTML = `<div class="view-enter">${renderFn()}</div>`;
  bindViewEvents();
}

// Bildirim paneli render sonrası doldurulduğu için olayları ayrı bağlanır.
function bindNotifEvents(kok) {
  const bid = state.branchId;

  kok.querySelectorAll("[data-notif-read]").forEach(el =>
    el.addEventListener("click", async () => {
      const anahtar = el.dataset.notifRead;
      Bildirim.okundu(bid, anahtar);

      // Kayıtlı bildirimlerde okundu Firestore'a da yazılır; yerel
      // işaret yalnızca bu cihazda geçerli olurdu ve veli telefonunu
      // değiştirince bildirim geri gelirdi.
      const { kayitliBildirimListesi, kayitOkunduIsaretle } =
        await import("./domain/bildirim-kayitlari.js");
      const kayit = kayitliBildirimListesi(bid).find(x => x.key === anahtar);
      if (kayit) await kayitOkunduIsaretle(bid, kayit.belgeId);

      render();
    }));

  kok.querySelectorAll("[data-notif-dismiss]").forEach(el =>
    el.addEventListener("click", () => { Bildirim.kapat(bid, el.dataset.notifDismiss); render(); }));

  kok.querySelectorAll("[data-notif-go]").forEach(el =>
    el.addEventListener("click", () => {
      state.notifOpen = false;
      location.hash = el.dataset.notifGo;
    }));

  const hepsi = kok.querySelector("[data-notif-allread]");
  if (hepsi) hepsi.addEventListener("click", () => {
    for (const b of bildirimler().filter(x => !x.okundu)) Bildirim.okundu(bid, b.key);
    render();
  });

  kok.querySelectorAll("[data-notif-send]").forEach(el =>
    el.addEventListener("click", () => {
      const ayrac = el.dataset.notifSend.lastIndexOf(":");
      const key = el.dataset.notifSend.slice(0, ayrac);
      const kanal = el.dataset.notifSend.slice(ayrac + 1);
      const b = bildirimler().find(x => x.key === key);
      if (!b) return;

      Bildirim.gonder(bid, {
        id: `gnd-${Date.now().toString(36)}`,
        key, kanal,
        alici: b.studentId ? (stu(b.studentId)?.parent ?? "Veli") : "Yönetim",
        aliciTipi: b.studentId ? "veli" : "yonetim",
        at: new Date().toISOString().slice(0, 16),
        metin: b.metin,
        // Entegrasyon kurulmamışsa kayıt "kuyrukta" kalır; gerçek servis
        // bağlandığında bu kayıtlar işlenebilir.
        durum: KANALLAR[kanal]?.hazir ? "iletildi" : "kuyrukta",
      });
      render();
    }));
}

export function bindViewEvents() {
  bindPhotoEvents(document.getElementById("view"));
  bindApplicationEvents(document.getElementById("view"));

  document.querySelectorAll("[data-student]").forEach(el =>
    el.addEventListener("click", e => {
      e.stopPropagation();
      const ogrenci = stu(el.dataset.student);
      if (ogrenci && !ogrenciyiGorebilir(ogrenci)) return;
      openStudentModal(el.dataset.student);
    }));

  document.querySelectorAll("[data-goto]").forEach(el =>
    el.addEventListener("click", () => location.hash = "#/" + el.dataset.goto));

  document.querySelectorAll("[data-class]").forEach(el =>
    el.addEventListener("click", () => location.hash = `#/siniflar/${el.dataset.class}`));

  document.querySelectorAll("[data-staff]").forEach(el =>
    el.addEventListener("click", e => { e.stopPropagation(); location.hash = `#/personel/${el.dataset.staff}`; }));

  document.querySelectorAll("[data-clsfilter]").forEach(el =>
    el.addEventListener("click", () => { state.studentClass = el.dataset.clsfilter; render(); }));

  document.querySelectorAll("[data-payfilter]").forEach(el =>
    el.addEventListener("click", () => { state.payFilter = el.dataset.payfilter; render(); }));

  document.querySelectorAll("[data-thread]").forEach(el =>
    el.addEventListener("click", () => {
      state.activeThread = el.dataset.thread;
      const m = B().messages.find(x => x.id === el.dataset.thread);
      if (m) Mesajlar.okunduIsaretle(state.branchId, m);
      render();
    }));

  // İlaç dozu kaydı — veli izni yoksa repo katmanı zaten reddeder.
  document.querySelectorAll("[data-givemed]").forEach(el =>
    el.addEventListener("click", () => {
      if (!yapabilir("ilacUygula")) return;
      const med = aktifIlaclar(state.branchId).find(m => m.id === el.dataset.givemed);
      if (!med) return;
      const simdi = new Date();
      const zaman = `${simdi.toISOString().slice(0, 10)}T${simdi.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}`;
      try {
        Ilac.uygula(state.branchId, med, stu(med.studentId), {
          at: zaman,
          dose: med.dose,
          staffId: B().classes.find(c => c.id === stu(med.studentId)?.classId)?.teacherId ?? null,
          note: "",
        });
      } catch (err) {
        alert(err.message);
        return;
      }
      render();
    }));

  document.querySelectorAll("[data-notifyincident]").forEach(el =>
    el.addEventListener("click", () => {
      const olay = olaylar(state.branchId).find(o => o.id === el.dataset.notifyincident);
      if (!olay) return;
      Olay.veliBilgilendir(state.branchId, olay, stu(olay.studentId), new Date().toISOString().slice(0, 16));
      render();
    }));

  // Belge ve ödeme (§4)
  document.querySelectorAll("[data-belge]").forEach(el =>
    el.addEventListener("click", e => {
      e.stopPropagation();
      const [sid, period] = el.dataset.belge.split(":");
      const ogrenci = stu(sid) ?? cocuklarim().find(x => x.id === sid);
      if (!ogrenci) return;
      const bid = ogrenci.branchId ?? state.branchId;
      const inv = subeBulHerYerde(bid)?.payments
        .find(p => p.studentId === sid && p.period === period);
      if (inv) belgeAc(ogrenci, inv, bid);
    }));

  document.querySelectorAll("[data-odemelink]").forEach(el =>
    el.addEventListener("click", e => {
      e.stopPropagation();
      const [sid, period] = el.dataset.odemelink.split(":");
      const ogrenci = stu(sid) ?? cocuklarim().find(x => x.id === sid);
      if (!ogrenci) return;
      const bid = ogrenci.branchId ?? state.branchId;
      const inv = subeBulHerYerde(bid)?.payments
        .find(p => p.studentId === sid && p.period === period);
      if (!inv) return;
      const link = odemeBaglantisi(ogrenci, inv, bid);
      if (link?.url) window.open(link.url, "_blank");
      else alert(`${link?.label ?? "Ödeme"} entegrasyonu henüz kurulmadı.\nReferans: ${link?.referans ?? "—"}`);
    }));

  // Dışa aktarma (§11)
  document.querySelectorAll("[data-aktarim]").forEach(el =>
    el.addEventListener("click", () => {
      const kod = el.dataset.aktarim;
      if (!yapabilir(AKTARIMLAR[kod]?.yetki)) return;
      const dosya = aktarimUret(kod, state.branchId);
      dosyaIndir(dosya);
      Aktarim.kaydet(state.branchId, kod, dosya);
      render();
    }));

  document.querySelectorAll("[data-mesajtab]").forEach(el =>
    el.addEventListener("click", () => { state.mesajTab = el.dataset.mesajtab; render(); }));

  // Toplu duyuru (§13)
  document.querySelectorAll("[data-newduyuru]").forEach(el =>
    el.addEventListener("click", () => { if (yapabilir("mesajYaz")) openDuyuruFormu(); }));

  document.querySelectorAll("[data-duyuruyanit]").forEach(el =>
    el.addEventListener("click", () => {
      const [duyuruId, sid, cevap] = el.dataset.duyuruyanit.split(":");
      const d = duyurular(state.branchId).find(x => x.id === duyuruId);
      if (!d) return;
      Duyuru.yanitla(state.branchId, d, sid, cevap);
      render();
    }));

  document.querySelectorAll("[data-duyuruhatirlat]").forEach(el =>
    el.addEventListener("click", () => {
      if (!yapabilir("mesajYaz")) return;
      const d = duyurular(state.branchId).find(x => x.id === el.dataset.duyuruhatirlat);
      if (!d) return;
      const bekleyen = duyuruDurumu(d, state.branchId).yanitBekleyenler;
      for (const s of bekleyen) {
        Bildirim.gonder(state.branchId, {
          id: `gnd-${Date.now().toString(36)}-${s.id}`,
          key: `duyuru:${d.id}`,
          kanal: d.kanallar.includes("sms") ? "sms" : "uygulama",
          alici: veliler(s)[0]?.name ?? "Veli",
          aliciTipi: "veli",
          at: new Date().toISOString().slice(0, 16),
          metin: `${d.baslik} — yanıtınız bekleniyor.`,
          durum: "kuyrukta",
        });
      }
      render();
    }));

  document.querySelectorAll("[data-odemetab]").forEach(el =>
    el.addEventListener("click", () => { state.odemeTab = el.dataset.odemetab; render(); }));

  // Tahsilat hatırlatması gönder (§5)
  document.querySelectorAll("[data-hatirlat]").forEach(el =>
    el.addEventListener("click", () => {
      if (!yapabilir("odemeDuzenle")) return;
      const [sid, period, basamakId] = el.dataset.hatirlat.split(":");
      const h = hatirlatmaTablosu(state.branchId)
        .find(x => x.student.id === sid && x.inv.period === period);
      if (!h || !h.basamak) return;

      const basamak = MERDIVEN.find(m => m.id === basamakId) ?? h.basamak;
      Hatirlatma.gonder(state.branchId, {
        id: `gnd-${Date.now().toString(36)}`,
        key: h.key,
        basamak: basamak.id,
        basamakLabel: basamak.label,
        kanal: basamak.kanal,
        alici: veliler(h.student)[0]?.name ?? "Veli",
        aliciTipi: "veli",
        at: new Date().toISOString().slice(0, 16),
        metin: metinUret(basamak.id, { student: h.student, inv: h.inv, kalan: h.kalan, branchId: state.branchId }),
        durum: KANALLAR[basamak.kanal]?.hazir ? "iletildi" : "kuyrukta",
      });
      render();
    }));

  // Taksit tahsilatı
  document.querySelectorAll("[data-taksit]").forEach(el =>
    el.addEventListener("click", () => {
      if (!yapabilir("odemeDuzenle")) return;
      const [planId, no] = el.dataset.taksit.split(":");
      const plan = taksitPlanlari(state.branchId).find(p => p.id === planId);
      if (!plan) return;
      Hatirlatma.taksitOdendi(state.branchId, plan, Number(no), stu(plan.studentId));
      render();
    }));

  document.querySelectorAll("[data-taksitplan]").forEach(el =>
    el.addEventListener("click", () => openTaksitFormu(el.dataset.taksitplan)));

  document.querySelectorAll("[data-sistemtab]").forEach(el =>
    el.addEventListener("click", () => { state.sistemTab = el.dataset.sistemtab; render(); }));

  // Plan ve abonelik durumu değişikliği — yalnızca sistem operatörü.
  document.querySelectorAll("[data-planset]").forEach(el =>
    el.addEventListener("click", () => {
      if (!yapabilir("planDegistir")) return;
      const [tid, planId] = el.dataset.planset.split(":");
      const k = kiraciBul(tid);
      if (!k || k.subscription.planId === planId) return;
      Kiraci.planDegistir(k, planId, k.subscription.planId);
      render();
    }));

  document.querySelectorAll("[data-statusset]").forEach(el =>
    el.addEventListener("click", () => {
      if (!yapabilir("planDegistir")) return;
      const [tid, durum] = el.dataset.statusset.split(":");
      const k = kiraciBul(tid);
      if (!k || k.subscription.status === durum) return;
      Kiraci.durumDegistir(k, durum, k.subscription.status);
      render();
    }));

  document.querySelectorAll("[data-kiraci]").forEach(el =>
    el.addEventListener("click", () => {
      if (!kiraciDegistir(el.dataset.kiraci)) return;
      location.hash = "#/" + varsayilanGorunum();
      routeFromHash();
      render();
    }));

  document.querySelectorAll("[data-export]").forEach(el =>
    el.addEventListener("click", e => {
      e.stopPropagation();
      const ogrenci = stu(el.dataset.export);
      if (!ogrenci || !yapabilir("ogrenciDuzenle")) return;
      dokumIndir(dokumDosyasi(ogrenci, state.branchId));
    }));

  document.querySelectorAll("[data-finanstab]").forEach(el =>
    el.addEventListener("click", () => { state.finansTab = el.dataset.finanstab; render(); }));

  document.querySelectorAll("[data-atttab]").forEach(el =>
    el.addEventListener("click", () => { state.attendanceTab = el.dataset.atttab; render(); }));

  document.querySelectorAll("[data-checkout]").forEach(el =>
    el.addEventListener("click", e => {
      e.stopPropagation();
      if (!yapabilir("cikisKaydet")) return;
      openCheckoutModal(el.dataset.checkout);
    }));

  document.querySelectorAll("[data-imza-goster]").forEach(el =>
    el.addEventListener("click", async e => {
      e.stopPropagation();
      const id = el.dataset.imzaGoster;
      el.disabled = true;
      const { imzayiCoz } = await import("./lib/imza.js");
      const { imzayiGoster } = await import("./components/imzaModal.js");
      imzayiGoster(stu(id), B().attendance[id], await imzayiCoz(B().attendance[id]));
      el.disabled = false;
    }));

  document.querySelectorAll("[data-checkoutundo]").forEach(el =>
    el.addEventListener("click", e => {
      e.stopPropagation();
      const id = el.dataset.checkoutundo;
      Yoklama.cikisGeriAl(state.branchId, stu(id), B().attendance[id]);
      render();
    }));

  document.querySelectorAll("[data-att]").forEach(el =>
    el.addEventListener("click", () => {
      const id = el.dataset.att;
      // Eğitmen yalnızca kendi sınıfının yoklamasını değiştirebilir (§2).
      if (!sinifaYazabilir(stu(id)?.classId)) return;
      const a = B().attendance[id];
      const cycle = { geldi: "izinli", izinli: "gelmedi", gelmedi: "geldi" };
      const durum = cycle[a.status];
      const saat = () => new Date().toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
      const alan = durum === "geldi"
        ? { ...a, status: durum, in: a.in ?? saat() }
        : { ...a, status: durum, in: null, out: null };
      Yoklama.durumDegistir(state.branchId, stu(id), durum, alan);
      render();
    }));

  const search = document.getElementById("stuSearch");
  if (search) {
    search.addEventListener("input", () => {
      state.studentQuery = search.value;
      render();
      const el = document.getElementById("stuSearch");
      el.focus();
      el.setSelectionRange(el.value.length, el.value.length);
    });
  }

  const send = document.getElementById("msgSend");
  if (send) send.addEventListener("click", () => {
    const input = document.getElementById("msgInput");
    const text = input.value.trim();
    if (!text) return;
    const m = B().messages.find(x => x.id === (state.activeThread ?? B().messages[0]?.id));
    if (!m) return;
    Mesajlar.gonder(state.branchId, m, text);
    render();
  });
}

// ---------- Kabuk olayları ----------
// Modül yüklenirken değil, main.js açılışta bir kez çağırdığında bağlanır;
// böylece modül testte DOM olmadan da içe aktarılabilir.
export { routeFromHash };

/**
 * Onay ve ret aynı iskeleti paylaşır: düğmeyi kilitle, çağrıyı yap,
 * sonucu formun içinde göster. Kilitleme şart — onay kiracı açıyor
 * ve iki kez tıklanırsa ikinci çağrı "already-exists" ile döner,
 * kullanıcı da onaylanmadı sanır.
 */
async function basvuruIslemi(form, is, basariMetni) {
  if (!form) return;
  const durum = form.querySelector("[data-basvuru-durum]");
  const dugmeler = [...form.querySelectorAll("button")];
  dugmeler.forEach(d => { d.disabled = true; });
  if (durum) { durum.textContent = "İşleniyor…"; durum.className = "text-sm text-inksoft self-center"; }

  try {
    const m = await import("./domain/firebase-auth.js");
    await is(m);
    if (durum) { durum.textContent = basariMetni; durum.className = "text-sm text-teal font-semibold self-center"; }
    const { basvurulariTazele } = await import("./views/sistemBasvuru.js");
    basvurulariTazele();
  } catch (hata) {
    if (durum) { durum.textContent = hata?.message ?? "Hata."; durum.className = "text-sm text-coral font-semibold self-center"; }
    dugmeler.forEach(d => { d.disabled = false; });
  }
}

function davetDurumuGoster(mesaj, hataMi) {
  const el = document.querySelector("[data-davet-durum]");
  if (!el) return;
  el.textContent = mesaj;
  el.className = `text-sm font-semibold mb-3 ${hataMi ? "text-coral" : "text-teal"}`;
}

export function wireShell() {
  window.addEventListener("hashchange", () => { routeFromHash(); render(); closeSidebar(); });

  // Veli daveti — öğrenci kartından. E-posta öğrenci kaydına da
  // yazılıyor ki bir dahaki açılışta alan dolu gelsin.
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("[data-veli-davet]");
    if (!form) return;
    e.preventDefault();

    const ogrenciId = form.dataset.veliDavet;
    const email = new FormData(form).get("email");
    const durum = form.parentElement.querySelector("[data-veli-davet-durum]");
    const dugme = form.querySelector("button[type=submit]");
    dugme.disabled = true;

    const yaz = (mesaj, hataMi) => {
      if (!durum) return;
      durum.textContent = mesaj;
      durum.className = `text-[11px] font-semibold mt-1 ${hataMi ? "text-coral" : "text-teal"}`;
    };
    yaz("Gönderiliyor…", false);

    try {
      const ogrenci = stu(ogrenciId);
      const m = await import("./domain/firebase-auth.js");
      await m.davetEt({
        email,
        role: "veli",
        branchId: state.branchId,
        name: ogrenci?.parent ?? email,
        children: [ogrenciId],
      });
      if (ogrenci && ogrenci.parentEmail !== email) {
        Ogrenciler.guncelle(state.branchId, ogrenci, { parentEmail: email },
          `${ogrenci.name} için veli e-postası tanımlandı`);
      }
      yaz("Davet edildi.", false);
    } catch (hata) {
      yaz(hata?.message ?? "Davet gönderilemedi.", true);
    } finally {
      dugme.disabled = false;
    }
  });

  // Davet formu.
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("[data-davet-form]");
    if (!form) return;
    e.preventDefault();

    const veri = Object.fromEntries(new FormData(form));
    const subeId = form.querySelector("[data-sube]")?.dataset.sube;
    const dugme = form.querySelector("button[type=submit]");
    dugme.disabled = true;

    try {
      const m = await import("./domain/firebase-auth.js");
      // tenantId GÖNDERİLMİYOR — sunucu onu çağıranın claim'inden
      // alıyor. Buradan göndermek başka kuruma davet yolunu açardı.
      await m.davetEt({ email: veri.email, role: veri.role, branchId: subeId });
      form.reset();
      davetDurumuGoster(`${veri.email} davet edildi.`, false);
      const { davetleriTazele } = await import("./views/davetler.js");
      davetleriTazele();
    } catch (hata) {
      davetDurumuGoster(hata?.message ?? "Davet gönderilemedi.", true);
    } finally {
      dugme.disabled = false;
    }
  });

  // Başvuru onayı bir form gönderimi — kiracı kimliği, plan ve şube
  // listesi formdan okunuyor.
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("[data-basvuru]");
    if (!form) return;
    e.preventDefault();

    const { subeleriAyristir } = await import("./views/sistemBasvuru.js");
    const veri = Object.fromEntries(new FormData(form));
    const branches = subeleriAyristir(veri.subeler);

    if (!branches.length) {
      const durum = form.querySelector("[data-basvuru-durum]");
      if (durum) { durum.textContent = "En az bir şube gerekli."; durum.className = "text-sm text-coral font-semibold self-center"; }
      return;
    }

    basvuruIslemi(form, async (m) => {
      await m.basvuruyuOnayla({
        uid: form.dataset.basvuru,
        tenantId: veri.tenantId,
        planId: veri.planId,
        branches,
      });
    }, "Onaylandı — kurum açıldı.");
  });

  document.getElementById("notifBtn").addEventListener("click", e => {
    e.stopPropagation();
    state.notifOpen = !state.notifOpen;
    render();
  });

  document.getElementById("userBtn").addEventListener("click", e => {
    e.stopPropagation();
    document.getElementById("userMenu").classList.toggle("hidden");
  });

  document.getElementById("branchBtn").addEventListener("click", e => {
    e.stopPropagation();
    document.getElementById("branchMenu").classList.toggle("hidden");
  });
  document.addEventListener("click", e => {
    if (!e.target.closest("#branchMenu") && !e.target.closest("#branchBtn"))
      document.getElementById("branchMenu").classList.add("hidden");
    if (!e.target.closest("#userMenu") && !e.target.closest("#userBtn"))
      document.getElementById("userMenu").classList.add("hidden");
    if (state.notifOpen && !e.target.closest("#notifPanel") && !e.target.closest("#notifBtn")) {
      state.notifOpen = false;
      render();
      return;
    }

    // ---------- Davet iptali (kurum yöneticisi) ----------
    const iptalBtn = e.target.closest("[data-davet-iptal]");
    if (iptalBtn) {
      const email = iptalBtn.dataset.davetIptal;
      iptalBtn.disabled = true;
      iptalBtn.textContent = "kesiliyor…";
      import("./domain/firebase-auth.js")
        .then(m => m.davetiIptalEt(email))
        .then(async () => {
          const { davetleriTazele } = await import("./views/davetler.js");
          davetleriTazele();
        })
        .catch(hata => {
          iptalBtn.disabled = false;
          iptalBtn.textContent = "Erişimi kes";
          davetDurumuGoster(hata?.message ?? "İptal edilemedi.", true);
        });
      return;
    }

    // ---------- Kreş başvurusu: onay / ret (sistem operatörü) ----------
    const retBtn = e.target.closest("[data-ret]");
    if (retBtn) {
      const form = retBtn.closest("[data-basvuru]");
      basvuruIslemi(form, async (m) => {
        await m.basvuruyuReddet({ uid: retBtn.dataset.ret });
      }, "Reddedildi.");
      return;
    }

    // Gerçek girişte çıkış: oturumu kapatıp sayfayı baştan yükle.
    // Yerinde temizlemek yerine yenilemek bilinçli — ekranda kalmış
    // hiçbir veri parçasının yeni oturuma sızmaması için.
    if (e.target.closest("[data-cikis]")) {
      import("./domain/firebase-auth.js")
        .then(m => m.cikis())
        .finally(() => location.reload());
      return;
    }

    const uBtn = e.target.closest("[data-user]");
    if (uBtn) {
      const kullanici = demoKullanicilar().find(u => u.uid === uBtn.dataset.user);
      if (kullanici) {
        girisYap(kullanici);
        state.branchId = erisilebilirSubeler()[0]?.id ?? state.branchId;
        state.classId = null;
        state.staffId = null;
        state.activeThread = null;
        document.getElementById("userMenu").classList.add("hidden");
        location.hash = "#/" + varsayilanGorunum();
        routeFromHash();
        render();
      }
      return;
    }
    const tBtn = e.target.closest("[data-branch]");
    if (tBtn && subeyeErisebilir(tBtn.dataset.branch)) {
      state.branchId = tBtn.dataset.branch;
      state.activeThread = null;
      state.studentQuery = "";
      state.studentClass = "all";
      state.payFilter = "all";
      // sınıf ve personel şubeye özel — detay açıksa listeye dön
      state.classId = null;
      state.staffId = null;
      state.photoDraft = null;
      state.photoError = null;
      if (location.hash.startsWith("#/siniflar/")) location.hash = "#/siniflar";
      if (location.hash.startsWith("#/personel/")) location.hash = "#/personel";
      document.getElementById("branchMenu").classList.add("hidden");
      render();
    }
  });

  document.getElementById("modalOverlay").addEventListener("click", closeModal);
  document.addEventListener("keydown", e => { if (e.key === "Escape") { closeModal(); closeSidebar(); } });

  // Mobil kenar çubuğu
  document.getElementById("menuBtn").addEventListener("click", () => {
    sidebar().classList.remove("-translate-x-full");
    overlay().classList.remove("hidden");
  });
  overlay().addEventListener("click", closeSidebar);
}

const sidebar = () => document.getElementById("sidebar");
const overlay = () => document.getElementById("sidebarOverlay");

export function closeSidebar() {
  sidebar().classList.add("-translate-x-full");
  overlay().classList.add("hidden");
}

